import { Box, Flex, Text, VStack } from "@chakra-ui/react"; //Vishy 2025-02-18 build warning "IconButton, Image" not used, so removed
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useToastWrapper } from "../../../Wrapper/toastWrapper";
import { CommonAPI } from "../../../Apis/commonApi";
import { RfxAPI } from "../../../Apis/rfxAPI"; // Claude: RFX badge polling 03-03-2026
import actions from "../../../redux/Actions";
import CustomIconButton from "../../Common/CustomIconButton";
import AiChatDrawer from "../../Common/AiChatDrawer"; // Claude: floating AI drawer 24-02-2026

import {
  MdFormatListBulleted,
  MdOutlineCalendarMonth,
  MdCalendarMonth,
  MdOutlineFormatListBulleted,
  MdDashboard,
  MdOutlineDashboard,
  MdAssignment,
  MdOutlineAssignment,
  MdAutoAwesome,
  MdLogout,
  MdPermMedia,
} from "react-icons/md";
import { Sellerscreens } from "../../../Constants/data";

type Props = {
  children: React.ReactNode;
};

const noFooter = [
  "/seller/company",
  "/seller/chat",
  "/seller/notifications",
];

const SellerLayout = ({ children }: Props) => {
  const location = useLocation();

  const navigate = useNavigate();

  const { user } = useSelector((state: any) => state);
  const { sellerMenu } = useSelector((state: any) => state);

  // const { error, info } = useToastWrapper(); //Vishy 2025-02-18 build warning not used, so removed

  const [authState, setAuthState] = useState(!!(user && user?.role === "Seller"));
  // Claude: RFX badge — red dot when new RFXs appear in browse list 03-03-2026
  const [showRfxBadge, setShowRfxBadge] = useState(false);
  const [lastRfxCount, setLastRfxCount] = useState(0);

  const dispatch = useDispatch();
  const { error } = useToastWrapper();

  // Claude: access control — blocked/inactive→login, unverified/resubmitted→profile only 21-03-2026
  useEffect(() => {
    if (user && user?.role === "Seller") {
      const vStatus = user?.verificationStatus;
      if (vStatus === "blocked" || vStatus === "inactive") {
        dispatch(actions.user.logout());
        navigate("/login");
        return;
      }
      // Claude: unverified/resubmitted locked to profile page only 21-03-2026
      if ((vStatus === "unverified" || vStatus === "resubmitted") && location.pathname !== "/seller/profile") {
        navigate("/seller/profile");
        return;
      }
      setAuthState(true);
    } else {
      navigate("/login");
    }
  }, [user, location.pathname]);

  const fetchNotification = async () => {
    try {
      const res = await CommonAPI.getNotifications();
      if (res.success) {
        const { notifications, unread } = res.data.data;

        dispatch(
          actions.notification.get({
            notifications,
            unreadNotifications: unread,
          })
        );
      }
    } catch (err) {
      console.log("Error getting notification", err);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      fetchNotification();
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  // Claude: N47 — auto-open AI chat drawer once per browser session 26-03-2026
  useEffect(() => {
    const key = "aftr_seller_ai_opened";
    if (!sessionStorage.getItem(key)) {
      sessionStorage.setItem(key, "1");
      dispatch(actions.sellerMenu.set({ aiChatOpen: true }));
    }
  }, []);

  // Claude: RFX badge polling — check for new open RFXs every 5 min 03-03-2026
  const checkRfxBadge = async () => {
    try {
      const res = await RfxAPI.browseRfxs();
      if (res.success) {
        const total = (res.data as any[]).length;
        setLastRfxCount(total);
        const seen = parseInt(localStorage.getItem('seller_rfx_seen') ?? '-1', 10);
        if (seen === -1) {
          localStorage.setItem('seller_rfx_seen', String(total));
        } else if (total > seen) {
          setShowRfxBadge(true);
        }
      }
    } catch {}
  };

  useEffect(() => {
    checkRfxBadge();
    const interval = setInterval(checkRfxBadge, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  // Claude: close AI chat drawer on every nav tap 24-02-2026
  const MenuItemClick = (screenName: string) => {
    dispatch(actions.sellerMenu.set({ activeMenu: screenName, aiChatOpen: false }));
  };

  // Claude: unverified/resubmitted/provisional nav gate — show toast, block navigation 21-03-2026
  const vStatus = user?.verificationStatus;
  const isRestricted = vStatus === "unverified" || vStatus === "resubmitted";
  const isProvisional = vStatus === "provisional";
  const restrictedToast = () => {
    error(
      vStatus === "resubmitted"
        ? "Your profile is pending review. Contact support@aftr.network for any assistance."
        : "Please update your profile and submit. Contact support@aftr.network for any assistance."
    );
  };
  const provisionalToast = () => error("Profile is pending review and has provisional access only.");
  const handleNav = (screenName: string, path: string) => {
    if (isRestricted) { restrictedToast(); return; }
    MenuItemClick(screenName);
    navigate(path);
  };

  return (
    // <MobileLayout>
    <>
      {/* Claude: Dark left/right borders matching nav bar and header 17-02-2026 */}
      <Flex
        maxW={"600px"}
        w="100%"
        position={"relative"}
        flexDirection="column"
        alignSelf={"center"}
        mx={"auto"}
        display={"flex"}
        minH={"100dvh"}
        maxH={"100dvh"}
        overflow={"auto"}
        borderLeft={"2px solid #0E122F"}
        borderRight={"2px solid #0E122F"}
        bg={"#FFF5EE"}
      >
        <Box
          flexGrow={1}
          overflow={"auto"}
          pb={"20px"}
          display={"flex"}
          marginBottom={"65px"}
        >
          {authState && children}
        </Box>
        {/* Claude: Floating logout button — visible only for unverified/resubmitted users 21-03-2026 */}
        {isRestricted && (
          <Box
            style={{
              position: "fixed",
              bottom: "75px",
              width: "100%",
              maxWidth: "596px",
              display: "flex",
              justifyContent: "flex-start",
              paddingLeft: "16px",
              pointerEvents: "none",
            }}
          >
            <Flex
              w="44px"
              h="44px"
              borderRadius="50%"
              bg="#0E122F"
              alignItems="center"
              justifyContent="center"
              shadow="0px 4px 12px rgba(0,0,0,0.35)"
              cursor="pointer"
              style={{ pointerEvents: "auto" }}
              onClick={() => { dispatch(actions.user.logout()); navigate("/login"); }}
            >
              <MdLogout size={18} color="white" />
            </Flex>
          </Box>
        )}

        {/* Claude: Floating AI button — hidden for unverified/resubmitted/inactive users 21-03-2026 */}
        {/* Claude: pointerEvents none on container so it doesn't block hover/clicks on content below 03-03-2026 */}
        <Box
          style={{
            position: "fixed",
            bottom: "75px",
            width: "100%",
            maxWidth: "596px",
            display: ["unverified", "resubmitted", "inactive"].includes(user?.verificationStatus) ? "none" : "flex",
            justifyContent: "flex-end",
            paddingRight: "16px",
            pointerEvents: "none",
          }}
        >
          {/* Claude: AI label inside circle for visibility 25-02-2026 */}
          <Flex
            w="44px"
            h="44px"
            borderRadius="50%"
            bg="#0E122F"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            shadow="0px 4px 12px rgba(0,0,0,0.35)"
            cursor="pointer"
            style={{ pointerEvents: "auto" }}
            onClick={() => dispatch(actions.sellerMenu.set({
              activeMenu: sellerMenu.activeMenu,
              aiChatOpen: !sellerMenu.aiChatOpen,
            }))}
          >
            <MdAutoAwesome size={16} color="#FF5F12" />
            <Text fontSize="9px" color="white" fontWeight={600} lineHeight={1}>AI</Text>
          </Flex>
        </Box>

        {/* Claude: AI Chat drawer — auto-opens on Dashboard, toggled by floating button 24-02-2026 */}
        <AiChatDrawer role="Seller" />

        {noFooter.includes(location.pathname) ? null : (
          <Box
            w={"100%"}
            bg={"white"}
            shadow={"0px 0px 10px rgba(0, 0, 0, 0.1)"}
            // Claude: Dark top border, fits inside layout side borders 17-02-2026
            borderTop={"2px solid #0E122F"}
            style={{
              position: "fixed",
              bottom: 0,
              width: "100%",
              maxWidth: "596px",
              zIndex: 102,
            }}
          >
            {/* Claude: N47 — AI Chat removed; Catalog added; order: Opportunities|Catalog|Dashboard|Buyers|Meetings 26-03-2026 */}
            <Flex h={"65px"}>
              {/* Claude: all nav onClicks routed through handleNav — gates unverified/resubmitted 21-03-2026 */}
              <CustomIconButton
                width={"20%"}
                label={"Opportunities"}
                active={sellerMenu?.activeMenu == Sellerscreens.RFX}
                buttonBg={sellerMenu?.activeMenu == Sellerscreens.RFX ? "primary.main" : "transparent"}
                icon={sellerMenu?.activeMenu == Sellerscreens.RFX
                  ? <MdAssignment size={24} color={"#FF5F12"} />
                  : <MdOutlineAssignment size={24} color={"#1C1B1F"} />}
                showBadge={showRfxBadge}
                onClick={() => {
                  if (isRestricted) { restrictedToast(); return; }
                  MenuItemClick(Sellerscreens.RFX);
                  setShowRfxBadge(false);
                  localStorage.setItem('seller_rfx_seen', String(lastRfxCount));
                  navigate("/seller/rfxs");
                }}
              />
              <CustomIconButton
                width={"20%"}
                label={"Catalog"}
                active={sellerMenu?.activeMenu == Sellerscreens.CATALOG}
                buttonBg={sellerMenu?.activeMenu == Sellerscreens.CATALOG ? "primary.main" : "transparent"}
                icon={<MdPermMedia size={24} color={sellerMenu?.activeMenu == Sellerscreens.CATALOG ? "#FF5F12" : "#1C1B1F"} />}
                onClick={() => handleNav(Sellerscreens.CATALOG, "/seller/catalog")}
              />
              <CustomIconButton
                width={"20%"}
                label={"Dashboard"}
                active={sellerMenu?.activeMenu == Sellerscreens.HOME}
                buttonBg={sellerMenu?.activeMenu == Sellerscreens.HOME ? "primary.main" : "transparent"}
                icon={sellerMenu?.activeMenu == Sellerscreens.HOME
                  ? <MdDashboard size={24} color={"#FF5F12"} />
                  : <MdOutlineDashboard size={24} color={"#1C1B1F"} />}
                onClick={() => handleNav(Sellerscreens.HOME, "/seller")}
              />
              <CustomIconButton
                width={"20%"}
                label={"Buyers"}
                active={sellerMenu?.activeMenu == Sellerscreens.DETAILS}
                buttonBg={sellerMenu?.activeMenu == Sellerscreens.DETAILS ? "primary.main" : "transparent"}
                icon={sellerMenu?.activeMenu == Sellerscreens.DETAILS
                  ? <MdFormatListBulleted size={24} color={"#FF5F12"} />
                  : <MdOutlineFormatListBulleted size={24} color={"#1C1B1F"} />}
                onClick={() => handleNav(Sellerscreens.DETAILS, "/seller/list")}
              />
              <CustomIconButton
                width={"20%"}
                label={"Meetings"}
                active={sellerMenu?.activeMenu == Sellerscreens.CALENDAR}
                buttonBg={sellerMenu?.activeMenu == Sellerscreens.CALENDAR ? "primary.main" : "transparent"}
                icon={
                  sellerMenu?.activeMenu == Sellerscreens.CALENDAR ? (
                    <MdCalendarMonth size={24} color={"#FF5F12"} fontWeight={"light"} />
                  ) : (
                    <MdOutlineCalendarMonth size={24} color={"#1C1B1F"} fontWeight={"light"} />
                  )
                }
                onClick={() => {
                  if (isProvisional) { provisionalToast(); return; }
                  handleNav(Sellerscreens.CALENDAR, "/seller/calendar");
                }}
              />
            </Flex>
          </Box>
        )}
      </Flex>
    </>
  );
};

export default SellerLayout;
